import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';


import { MatSelectionList, MatListOption, MatListModule } from '@angular/material/list';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Observable, combineLatest } from 'rxjs';
import { CommonModule, UpperCasePipe } from '@angular/common';
import { AgentViewModel } from '../../../shared/models/AgentModels';
import { AgentService } from '../../../shared/services/agent.service';
import { map, startWith } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-agent-select-dialog',
    templateUrl: './agent-select-dialog.component.html',
    styleUrls: ['./agent-select-dialog.component.css'],
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatDialogModule, MatSelectionList, CdkScrollable, MatListModule, MatButtonModule, TranslatePipe, UpperCasePipe]
})
export class AgentSelectDialogComponent implements OnInit {

  _agentFilter = new UntypedFormControl('');
  _agents!: Observable<AgentViewModel[]>;


  constructor(private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<AgentSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private agentService: AgentService
  ) { }


  ngOnInit(): void {
    this.getAgents();
  }

  getAgents(){
    const allAgents$ = this.agentService.getAgents();

    this._agents = combineLatest([
      allAgents$,
      this._agentFilter.valueChanges.pipe(startWith('')),
    ]).pipe(
      map(([agents, filterValue]) => this.filterAgents(agents, filterValue ?? '')),
    );

  }

  private filterAgents(agents: AgentViewModel[], filterValue: string): AgentViewModel[] {
    const normalizedFilter = filterValue.trim().toLowerCase();

    if (!normalizedFilter) {
      return agents;
    }

    return agents.filter((agent) => {
      const firstName = agent.Agent?.FirstName ?? '';
      const lastName = agent.Agent?.LastName ?? '';
      const businessName = agent.Agent?.BusinessName ?? '';
      const searchText = [
        `${lastName}, ${firstName}`,
        `${firstName} ${lastName}`,
        businessName,
      ].join(' ').toLowerCase();

      return searchText.includes(normalizedFilter);
    });
  }

}
